import { useState, type FormEvent } from 'react'
import { api } from '@/lib/api'
import { Modal } from '@/shared/components/Modal'
import s from '@/shell/BetaFeedbackModal.module.css'

interface Props {
  onClose: () => void
}

type State = 'idle' | 'submitting' | 'success' | 'error'

export function BetaFeedbackModal({ onClose }: Props) {
  const [message, setMessage] = useState('')
  const [state, setState] = useState<State>('idle')
  const [errorMsg, setErrorMsg] = useState('')

  async function handleSubmit(e: FormEvent) {
    e.preventDefault()
    setState('submitting')
    setErrorMsg('')
    try {
      // name/email are derived from the authenticated session server-side
      await api.post('/api/forms', { use_case: message.trim() || undefined })
      setState('success')
    } catch (err) {
      setState('error')
      setErrorMsg(err instanceof Error ? err.message : 'Network error. Please try again.')
    }
  }

  return (
    <Modal
      track="beta_feedback"
      title="Send feedback"
      maxWidth={480}
      onClose={onClose}
    >
      <p className={s.lead}>Found something broken or have a suggestion? Let us know.</p>

      {state === 'success' ? (
        <div className={s.successWrap}>
          <div className="feedback-success">Thanks - we'll take a look.</div>
          <div style={{ marginTop: 16, textAlign: 'right' }}>
            <button className="btn btn-ghost btn-sm" onClick={onClose}>Close</button>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className={s.field}>
            <label className="field-label">Feedback</label>
            <textarea
              className="input"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="What broke, what felt off, or what would make this better?"
              rows={4}
              style={{ resize: 'vertical' }}
            />
          </div>
          {state === 'error' && (
            <div className="feedback-error" style={{ marginTop: 10 }}>{errorMsg}</div>
          )}
          <div className={s.actions}>
            <button className="btn btn-primary btn-sm" type="submit" disabled={state === 'submitting' || !message.trim()}>
              {state === 'submitting' ? 'Sending…' : 'Send feedback'}
            </button>
          </div>
        </form>
      )}
    </Modal>
  )
}
